export default __webpack_public_path__ + "static/img6-b20307e912962c89b707d62d2d611edd.png";